module.exports = __webpack_public_path__ + "img/service-NDW1.f4a6c5c5.svg";